<template>
	<nk-page commercialAccess="System">
		<template #badges>
			<!-- <nk-badge system="accounting">
				<nk-badge-item type="edition" :modelValue="retreiveIsEmpty()  ? 'new' : 'edit'"></nk-badge-item>
			</nk-badge> -->
		</template>

		<div class="container-fluid h-100 overflow-auto">
			<div class="nk-card h-100 overflow-auto">
				<Tree v-model:data="treeData" :options="componentOptions.tree" ref="tree" />
			</div>
		</div>
	</nk-page>
</template>

<script>
	import Tree from '~/components/checkbox-tree/Tree.vue'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { mapActions, mapGetters } from 'vuex'
	import _ from 'lodash'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import $sc from "@/plugins/shortcut.collection"

	export default {
		modal: {
			stateUID: 'cache-cleaner',
			size: 'md'
		},
		name: 'cache-cleaner',
		components: {
			Tree
		},
		data() {
			return {
				treeData: [],
				componentOptions: {
					tree: {
						treeDirection: 'rtl',
						customFields: {
							text: 'text',
							children: 'children',
							state: 'state'
						},
						checkboxOptions: {
							checkedColor: '#466eb5',
							unCheckedColor: 'white'
						}
					}
				},
				deleteBtn: {
					title: this.$t('delete'),
					isPrimary: true,
					icon: 'trash',
					handle: (button, page, e) => {
						e.preventDefault()
						this.showDeleteDialog()
					},
				},
			}
		},
		computed: {
			...mapGetters({
				allAppStates: 'appStates/all'
			})
		},
		created() {
			this.prepareAppStatesData()
		},
		mounted() {
			this.prepareWindow(this.$t('home.clear-app-cache'), [this.deleteBtn])
		},
		methods: {
			...mapActions({
				modify: 'appStates/modify'
			}),
			prepareAppStatesData() {

				let appStates = _.cloneDeep(this.allAppStates)
				let sortedAppStates = []

				appStates.forEach(item => {
					const splittedItem = item.key.split('_')

					if (splittedItem.length === 1) {
						item.text = item.name ? item.name : this.$t(`appState.items.${item.key}`)
						sortedAppStates.push(item)
						return
					}

					let groupKey = splittedItem[0]
					let foundIndex = sortedAppStates.findIndex(group => group.key === groupKey)

					item.text = item.name ? item.name : splittedItem[1]
					if (foundIndex > -1) {
						sortedAppStates[foundIndex].children.push(item)
					}
					else {

						const group = {
							text: this.$t(`appState.items.${groupKey}`),
							key: groupKey,
							children: [item]
						}
						sortedAppStates.push(group)
					}

				})
				let cache = {
					text: this.$t('appState.items.cache'),
					key: 'cache'
				}
				sortedAppStates = sortedAppStates.concat([
					{
						text: this.$t('appState.items.cache'),
						key: 'cache'
					},
					{
						text: this.$t('snapshot.title'),
						key: 'snapshot'
					}
				])
				this.treeData = sortedAppStates
			},
			showDeleteDialog() {
				dialog({
					title: this.$t('home.clear-app-cache'),
					body: this.$t('home.warning-message-clear-app-cache',),
					type: 'warning',
					// autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.delete()
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			delete() {
				let checked = this.$refs.tree.getLastLevelChecked().map(x => x.key)
				this.waitObj = this.$wait(this.$el)

				const tryRemoveKey = (key) => {
					var index = checked.indexOf(key)

					if (index > -1)
						checked.splice(index, 1)
				}

				if (checked.includes('cache')) {
					this.cache_clear()
					tryRemoveKey('cache')
				}

				if (checked.includes('snapshot')) {
					this.snapshotInstance.forceFlush()
					tryRemoveKey('snapshot')
				}

				if (checked.length) {
					post(Endpoints.getUrl('general.clearServerCache'), { keys: checked })
						.then((result) => {
							this.$toast(this.$t('msg.delete-success'), { type: 'success' })
							document.location = '/'
						})
						.finally(() => {
							this.waitObj.end()
						})
					return
				}

				this.$toast(this.$t('msg.delete-success'), { type: 'success' })
				document.location = '/'
				this.waitObj.end()

			},
		}
	}
</script>

<style></style>